import { createRootRoute, Outlet } from '@tanstack/react-router'

const RootComponent = () => (
  <div className='App'>
    <Outlet />
  </div>
)

export const Route = createRootRoute({
  component: RootComponent,
})
